import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  convertStraight,
  convertTime,
  convertTo12HourFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import {
  BinIcon1,
  CheckCircleIcon,
  CloudArrowIcon,
  CrossCircleIcon,
  EditIcon1,
  XCircleIcon,
} from "../../../images/icons/icons";

const CardAccordianInfo = ({
  rowData,
  setClickValues,
  handleDelete,
  onClickBtns,
  isReport,
  userInfoData,
}) => {
  const accountType = userInfoData?.account_type || "";

  const isAdmin = accountType === "admin";
  const isTrainer = accountType === "trainer";
  const isReceptionist = accountType === "receptionist";
  const isFitnessManager = accountType === "fitness_manager";

  return (
    <div className="all-followuo-info-container pt-track-acc">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="heade-info">
              <span className="title">member Last checkin</span>
              <span className="value">
                {rowData?.last_checkin_days_ago
                  ? rowData.last_checkin_days_ago?.replace(/_/g, " ")
                  : null}
              </span>
            </div>
          </Accordion.Header>

          <Accordion.Body>
            <div className="lead-multi-value-cols px20px pb20px mt15">
              {!isTrainer ? (
                <div className="label-value">
                  <span className="label">handover status</span>
                  <span className="value">
                    {" "}
                    {rowData?.handover_status?.replace(/_/g, " ") || "NA"}
                  </span>
                </div>
              ) : null}

              <div className="label-value">
                <span className="label"> trial status</span>
                <span className="value">
                  {rowData?.trial_status === "completed"
                    ? "Completed (Not Converted)"
                    : rowData?.trial_status === "trial_notdone_cnvrtd"
                    ? "Trial Not Done And Converted"
                    : rowData?.trial_status === "trial_done_cnvrtd"
                    ? "Trial Done And Converted"
                    : rowData.trial_status.replace(/_/g, " ") || "NA"}
                </span>
              </div>

              {!rowData?.is_pt_prspct && rowData?.pt_prspct_reason ? (
                <div className="label-value">
                  <span className="label">Reason For Not A PT Prospect</span>
                  <span className="value">
                    {rowData.pt_prspct_reason?.length <= 15 ? (
                      rowData.pt_prspct_reason
                    ) : rowData.pt_prspct_reason?.length >= 15 ? (
                      <>
                        {rowData.pt_prspct_reason?.substring(0, 15)}
                        <b
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setClickValues((prevs) => ({
                              ...prevs,
                              isModOpen: true,
                              name: "prospect_reason",
                              remarks: rowData.pt_prspct_reason,
                            }))
                          }
                        >
                          ...Read More
                        </b>
                      </>
                    ) : (
                      "NA"
                    )}
                  </span>
                </div>
              ) : null}

              {!isTrainer ? (
                <div className="label-value">
                  <span className="label">Assigned To (Trainer)</span>
                  <span className="value">
                    {rowData?.assigned_to_name || "NA"}
                    <br />

                    {rowData?.assigned_to_mobile || ""}
                    <br />
                    <small className={`lowercase`}>
                      {rowData?.assigned_to_email || ""}
                    </small>
                  </span>
                </div>
              ) : null}

              {!isTrainer ? (
                <div className="label-value">
                  <span className="label">Subscription Added By</span>
                  <span className="value">
                    {rowData?.sub_added_by_name || "NA"}
                  </span>
                </div>
              ) : null}

              <div className="label-value">
                <span className="label">Handover From</span>
                <span className="value">
                  {rowData?.assigned_by_name || "NA"}
                  <br />

                  {rowData?.assigned_by_mobile || ""}
                  <br />
                  {rowData?.assigned_by_email || ""}
                </span>
              </div>

              <div className="label-value">
                <span className="label">Subscription Added On</span>
                <span className="value">
                  {rowData?.date_added
                    ? formatDateTimezon(rowData.date_added)
                    : "-"}{" "}
                  <small
                    className={`capitalize ${rowData?.current_plan_status}`}
                  >
                    {rowData?.current_plan_status?.replace(/_/g, " ") || ""}
                  </small>
                </span>
              </div>

              <div className="label-value">
                <span className="label">Subscription Start/Expire Date</span>
                <span className="value">
                  {rowData?.regular_start_date
                    ? formatDateTimezon(rowData.regular_start_date)
                    : "-"}{" "}
                  TO{" "}
                  {rowData?.regular_expire_date
                    ? formatDateTimezon(rowData.regular_expire_date)
                    : "-"}
                </span>
              </div>

              <div className="label-value">
                <span className="label">Handover Date</span>
                <span className="value">
                  {rowData?.assigned_date
                    ? formatDateTimezon(rowData.assigned_date)
                    : "-"}{" "}
                  <br />
                  {rowData?.assigned_date_days_ago
                    ? `(${rowData.assigned_date_days_ago?.replace(/_/g, " ")})`
                    : ""}
                </span>
              </div>

              <div className="label-value">
                <span className="label">PT schedule date</span>
                <span className="value">
                  {rowData?.pt_schedule_date
                    ? convertStraight(rowData.pt_schedule_date)
                    : "-"}
                </span>
              </div>

              <div className="label-value">
                <span className="label">3 day trial</span>
                <span className="value">
                  <small className="icon">
                    {rowData?.three_day_assigned ? (
                      <CheckCircleIcon />
                    ) : (
                      <CrossCircleIcon />
                    )}
                  </small>
                  <br />
                  {rowData?.threeday_start_date
                    ? formatDateTimezon(rowData.threeday_start_date)
                    : "-"}
                  -{" "}
                  {rowData?.threeday_expire_date
                    ? formatDateTimezon(rowData.threeday_expire_date)
                    : "-"}
                  <br />
                  {(rowData?.threeday_slot_start ||
                    rowData?.threeday_slot_end) && (
                    <small>
                      {" "}
                      <b>
                        {rowData?.threeday_slot_start
                          ? convertTo12HourFormat(rowData.threeday_slot_start)
                          : "-"}
                      </b>{" "}
                      -{" "}
                      <b>
                        {rowData?.threeday_slot_end
                          ? convertTo12HourFormat(rowData.threeday_slot_end)
                          : "-"}
                      </b>
                    </small>
                  )}
                </span>
              </div>

              {/* <div className="label-value">
                <span className="label">Trial Date</span>
                <span className="value">
                  {rowData?.pt_initiate_date
                    ? formatDateTimezon(rowData.pt_initiate_date)
                    : "-"}{" "}
                  <br />
                  {rowData?.pt_initiate_date_days_ago
                    ? `(${rowData.pt_initiate_date_days_ago?.replace(
                        /_/g,
                        " "
                      )})`
                    : ""}
                </span>
              </div> */}

              <div className="label-value">
                <span className="label">member Last checkin</span>
                <span className="value">
                  {rowData?.last_checkin
                    ? formatDateTimezon(rowData.last_checkin)
                    : ""}{" "}
                  <br />
                  {rowData?.checkin_time
                    ? convertTime(rowData.checkin_time)
                    : ""}{" "}
                  <br />
                  {rowData?.last_checkin_days_ago
                    ? rowData.last_checkin_days_ago?.replace(/_/g, " ")
                    : null}
                </span>
              </div>
            </div>

            <div className="all-hidden-logs checked-unchecked-values">
              {isReport ? (
                <p className="value-heading">
                  Biomax Register
                  <span className="icon">
                    {rowData?.is_biomax_registered === "true" ? (
                      <CheckCircleIcon />
                    ) : (
                      <XCircleIcon />
                    )}
                  </span>
                </p>
              ) : null}

              {isReport ? (
                <p className="value-heading">
                  fitness profile status
                  <span className="icon">
                    {rowData?.isfitness_profile_completed === "completed" ? (
                      <CheckCircleIcon />
                    ) : (
                      <XCircleIcon />
                    )}
                  </span>
                </p>
              ) : null}

              {isReport && !isTrainer ? (
                <p className="value-heading">
                  Handover status
                  <span className="icon">
                    {rowData?.handover_status === "completed" ? (
                      <CheckCircleIcon />
                    ) : (
                      <XCircleIcon />
                    )}
                  </span>
                </p>
              ) : null}

              {/* {isReport ? (
                <p className="value-heading">
                  trial status
                  <span className="icon">
                    {rowData?.trial_status === "completed" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M20.0001 10.0001C20.0001 15.523 15.5229 20.0001 10.0001 20.0001C4.47718 20.0001 0 15.523 0 10.0001C0 4.47718 4.47718 0 10.0001 0C15.5229 0 20.0001 4.47718 20.0001 10.0001ZM7.55021 14.1187C7.75763 14.3273 8.03934 14.4452 8.33355 14.4464C8.62776 14.4452 8.90947 14.3273 9.11689 14.1187L15.228 8.00751C15.4101 7.79495 15.5052 7.52153 15.4944 7.24189C15.4836 6.96224 15.3677 6.69698 15.1698 6.49909C14.9719 6.30121 14.7066 6.18528 14.427 6.17448C14.1473 6.16368 13.8739 6.2588 13.6614 6.44083L8.33355 11.7631L5.78353 9.21863C5.57097 9.0366 5.29755 8.94148 5.01791 8.95228C4.73827 8.96308 4.473 9.07901 4.27512 9.27689C4.07724 9.47477 3.96131 9.74004 3.95051 10.0197C3.93971 10.2993 4.03483 10.5727 4.21686 10.7853L7.55021 14.1187Z"
                          fill="#09AA51"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6521 0 9.99998 0C7.34781 0 4.80429 1.05357 2.92892 2.92893C1.05356 4.8043 0 7.34784 0 10C0 12.6522 1.05356 15.1957 2.92892 17.0711C4.80429 18.9464 7.34781 20 9.99998 20C12.6521 20 15.1957 18.9464 17.0711 17.0711ZM12.5231 6.66988C12.4096 6.66661 12.2966 6.68658 12.191 6.72857C12.0855 6.77055 11.9897 6.83366 11.9095 6.91402L9.99864 8.82482L8.08784 6.91402C7.93761 6.76357 7.73556 6.67623 7.52305 6.66988C7.40953 6.66661 7.29657 6.68658 7.19105 6.72857C7.08554 6.77055 6.98967 6.83366 6.90943 6.91402C6.75319 7.07029 6.66543 7.28222 6.66543 7.50321C6.66543 7.72419 6.75319 7.93612 6.90943 8.0924L8.82025 10.0032L6.90943 11.914C6.75319 12.0703 6.66543 12.2822 6.66543 12.5032C6.66543 12.7242 6.75319 12.9361 6.90943 13.0924C7.0657 13.2486 7.27765 13.3364 7.49863 13.3364C7.71962 13.3364 7.93156 13.2486 8.08784 13.0924L9.99864 11.1816L11.9095 13.0924C12.0657 13.2486 12.2777 13.3364 12.4987 13.3364C12.7197 13.3364 12.9316 13.2486 13.0878 13.0924C13.2441 12.9361 13.3319 12.7242 13.3319 12.5032C13.3319 12.2822 13.2441 12.0703 13.0878 11.914L11.177 10.0032L13.0878 8.0924C13.2441 7.93612 13.3319 7.72419 13.3319 7.50321C13.3319 7.28222 13.2441 7.07029 13.0878 6.91402C12.9376 6.76357 12.7356 6.67623 12.5231 6.66988Z"
                          fill="#F4000C"
                        />
                      </svg>
                    )}
                  </span>
                </p>
              ) : null} */}
              {/* 
              {!isTrainer ? (
                <p className="value-heading">
                  Trainer Intro
                  <span className="icon">
                    {rowData?.trnr_intro_status === "completed" ? (
                      <CheckCircleIcon />
                    ) : (
                      <XCircleIcon />
                    )}
                  </span>
                </p>
              ) : null} */}

              <p className="value-heading">
                Trial status
                <span className="icon">
                  {rowData?.is_trial_done === true ? (
                    <CheckCircleIcon />
                  ) : (
                    <XCircleIcon />
                  )}
                </span>
              </p>

              <p className="value-heading">
                BCA Report
                <span className="icon">
                  {rowData?.bca_report_status === "completed" ? (
                    <a href={rowData.bca_report}>
                      <CloudArrowIcon color="#3396D3" />
                    </a>
                  ) : (
                    <XCircleIcon />
                  )}
                </span>
              </p>

              <>
                {/* <p className="value-heading">
                  Member Assesment
                  <span className="icon">
                    {rowData?.assesment_doc_status === "completed" ? (
                      <a href={rowData.assessment_doc}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
                            fill="#066CE3"
                          />
                        </svg>
                      </a>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6521 0 9.99998 0C7.34781 0 4.80429 1.05357 2.92892 2.92893C1.05356 4.8043 0 7.34784 0 10C0 12.6522 1.05356 15.1957 2.92892 17.0711C4.80429 18.9464 7.34781 20 9.99998 20C12.6521 20 15.1957 18.9464 17.0711 17.0711ZM12.5231 6.66988C12.4096 6.66661 12.2966 6.68658 12.191 6.72857C12.0855 6.77055 11.9897 6.83366 11.9095 6.91402L9.99864 8.82482L8.08784 6.91402C7.93761 6.76357 7.73556 6.67623 7.52305 6.66988C7.40953 6.66661 7.29657 6.68658 7.19105 6.72857C7.08554 6.77055 6.98967 6.83366 6.90943 6.91402C6.75319 7.07029 6.66543 7.28222 6.66543 7.50321C6.66543 7.72419 6.75319 7.93612 6.90943 8.0924L8.82025 10.0032L6.90943 11.914C6.75319 12.0703 6.66543 12.2822 6.66543 12.5032C6.66543 12.7242 6.75319 12.9361 6.90943 13.0924C7.0657 13.2486 7.27765 13.3364 7.49863 13.3364C7.71962 13.3364 7.93156 13.2486 8.08784 13.0924L9.99864 11.1816L11.9095 13.0924C12.0657 13.2486 12.2777 13.3364 12.4987 13.3364C12.7197 13.3364 12.9316 13.2486 13.0878 13.0924C13.2441 12.9361 13.3319 12.7242 13.3319 12.5032C13.3319 12.2822 13.2441 12.0703 13.0878 11.914L11.177 10.0032L13.0878 8.0924C13.2441 7.93612 13.3319 7.72419 13.3319 7.50321C13.3319 7.28222 13.2441 7.07029 13.0878 6.91402C12.9376 6.76357 12.7356 6.67623 12.5231 6.66988Z"
                          fill="#F4000C"
                        />
                      </svg>
                    )}
                  </span>
                </p>

                <p className="value-heading">
                  Member Profile
                  <span className="icon">
                    {rowData?.profile_doc_status === "completed" ? (
                      <a href={rowData.profile_doc}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
                            fill="#066CE3"
                          />
                        </svg>
                      </a>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6521 0 9.99998 0C7.34781 0 4.80429 1.05357 2.92892 2.92893C1.05356 4.8043 0 7.34784 0 10C0 12.6522 1.05356 15.1957 2.92892 17.0711C4.80429 18.9464 7.34781 20 9.99998 20C12.6521 20 15.1957 18.9464 17.0711 17.0711ZM12.5231 6.66988C12.4096 6.66661 12.2966 6.68658 12.191 6.72857C12.0855 6.77055 11.9897 6.83366 11.9095 6.91402L9.99864 8.82482L8.08784 6.91402C7.93761 6.76357 7.73556 6.67623 7.52305 6.66988C7.40953 6.66661 7.29657 6.68658 7.19105 6.72857C7.08554 6.77055 6.98967 6.83366 6.90943 6.91402C6.75319 7.07029 6.66543 7.28222 6.66543 7.50321C6.66543 7.72419 6.75319 7.93612 6.90943 8.0924L8.82025 10.0032L6.90943 11.914C6.75319 12.0703 6.66543 12.2822 6.66543 12.5032C6.66543 12.7242 6.75319 12.9361 6.90943 13.0924C7.0657 13.2486 7.27765 13.3364 7.49863 13.3364C7.71962 13.3364 7.93156 13.2486 8.08784 13.0924L9.99864 11.1816L11.9095 13.0924C12.0657 13.2486 12.2777 13.3364 12.4987 13.3364C12.7197 13.3364 12.9316 13.2486 13.0878 13.0924C13.2441 12.9361 13.3319 12.7242 13.3319 12.5032C13.3319 12.2822 13.2441 12.0703 13.0878 11.914L11.177 10.0032L13.0878 8.0924C13.2441 7.93612 13.3319 7.72419 13.3319 7.50321C13.3319 7.28222 13.2441 7.07029 13.0878 6.91402C12.9376 6.76357 12.7356 6.67623 12.5231 6.66988Z"
                          fill="#F4000C"
                        />
                      </svg>
                    )}
                  </span>
                </p>

                <p className="value-heading">
                  Fitness consultation
                  <span className="icon multi-icon">
                    {rowData?.ftns_cnsltnt_doc1_status === "completed" &&
                    rowData?.ftns_cnsltnt_doc2_status === "completed" ? (
                      <>
                        <a href={rowData.ftns_cnsltnt_doc1}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
                              fill="#066CE3"
                            />
                          </svg>
                        </a>
                        <a href={rowData.ftns_cnsltnt_doc2}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
                              fill="#066CE3"
                            />
                          </svg>
                        </a>
                      </>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6521 0 9.99998 0C7.34781 0 4.80429 1.05357 2.92892 2.92893C1.05356 4.8043 0 7.34784 0 10C0 12.6522 1.05356 15.1957 2.92892 17.0711C4.80429 18.9464 7.34781 20 9.99998 20C12.6521 20 15.1957 18.9464 17.0711 17.0711ZM12.5231 6.66988C12.4096 6.66661 12.2966 6.68658 12.191 6.72857C12.0855 6.77055 11.9897 6.83366 11.9095 6.91402L9.99864 8.82482L8.08784 6.91402C7.93761 6.76357 7.73556 6.67623 7.52305 6.66988C7.40953 6.66661 7.29657 6.68658 7.19105 6.72857C7.08554 6.77055 6.98967 6.83366 6.90943 6.91402C6.75319 7.07029 6.66543 7.28222 6.66543 7.50321C6.66543 7.72419 6.75319 7.93612 6.90943 8.0924L8.82025 10.0032L6.90943 11.914C6.75319 12.0703 6.66543 12.2822 6.66543 12.5032C6.66543 12.7242 6.75319 12.9361 6.90943 13.0924C7.0657 13.2486 7.27765 13.3364 7.49863 13.3364C7.71962 13.3364 7.93156 13.2486 8.08784 13.0924L9.99864 11.1816L11.9095 13.0924C12.0657 13.2486 12.2777 13.3364 12.4987 13.3364C12.7197 13.3364 12.9316 13.2486 13.0878 13.0924C13.2441 12.9361 13.3319 12.7242 13.3319 12.5032C13.3319 12.2822 13.2441 12.0703 13.0878 11.914L11.177 10.0032L13.0878 8.0924C13.2441 7.93612 13.3319 7.72419 13.3319 7.50321C13.3319 7.28222 13.2441 7.07029 13.0878 6.91402C12.9376 6.76357 12.7356 6.67623 12.5231 6.66988Z"
                          fill="#F4000C"
                        />
                      </svg>
                    )}
                  </span>
                </p>

                <p className="value-heading">
                  PT Prospect
                  <span className="icon">
                    {rowData?.is_pt_prspct ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M20.0001 10.0001C20.0001 15.523 15.5229 20.0001 10.0001 20.0001C4.47718 20.0001 0 15.523 0 10.0001C0 4.47718 4.47718 0 10.0001 0C15.5229 0 20.0001 4.47718 20.0001 10.0001ZM7.55021 14.1187C7.75763 14.3273 8.03934 14.4452 8.33355 14.4464C8.62776 14.4452 8.90947 14.3273 9.11689 14.1187L15.228 8.00751C15.4101 7.79495 15.5052 7.52153 15.4944 7.24189C15.4836 6.96224 15.3677 6.69698 15.1698 6.49909C14.9719 6.30121 14.7066 6.18528 14.427 6.17448C14.1473 6.16368 13.8739 6.2588 13.6614 6.44083L8.33355 11.7631L5.78353 9.21863C5.57097 9.0366 5.29755 8.94148 5.01791 8.95228C4.73827 8.96308 4.473 9.07901 4.27512 9.27689C4.07724 9.47477 3.96131 9.74004 3.95051 10.0197C3.93971 10.2993 4.03483 10.5727 4.21686 10.7853L7.55021 14.1187Z"
                          fill="#09AA51"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6521 0 9.99998 0C7.34781 0 4.80429 1.05357 2.92892 2.92893C1.05356 4.8043 0 7.34784 0 10C0 12.6522 1.05356 15.1957 2.92892 17.0711C4.80429 18.9464 7.34781 20 9.99998 20C12.6521 20 15.1957 18.9464 17.0711 17.0711ZM12.5231 6.66988C12.4096 6.66661 12.2966 6.68658 12.191 6.72857C12.0855 6.77055 11.9897 6.83366 11.9095 6.91402L9.99864 8.82482L8.08784 6.91402C7.93761 6.76357 7.73556 6.67623 7.52305 6.66988C7.40953 6.66661 7.29657 6.68658 7.19105 6.72857C7.08554 6.77055 6.98967 6.83366 6.90943 6.91402C6.75319 7.07029 6.66543 7.28222 6.66543 7.50321C6.66543 7.72419 6.75319 7.93612 6.90943 8.0924L8.82025 10.0032L6.90943 11.914C6.75319 12.0703 6.66543 12.2822 6.66543 12.5032C6.66543 12.7242 6.75319 12.9361 6.90943 13.0924C7.0657 13.2486 7.27765 13.3364 7.49863 13.3364C7.71962 13.3364 7.93156 13.2486 8.08784 13.0924L9.99864 11.1816L11.9095 13.0924C12.0657 13.2486 12.2777 13.3364 12.4987 13.3364C12.7197 13.3364 12.9316 13.2486 13.0878 13.0924C13.2441 12.9361 13.3319 12.7242 13.3319 12.5032C13.3319 12.2822 13.2441 12.0703 13.0878 11.914L11.177 10.0032L13.0878 8.0924C13.2441 7.93612 13.3319 7.72419 13.3319 7.50321C13.3319 7.28222 13.2441 7.07029 13.0878 6.91402C12.9376 6.76357 12.7356 6.67623 12.5231 6.66988Z"
                          fill="#F4000C"
                        />
                      </svg>
                    )}
                  </span>
                </p> */}
              </>

              {isReport ? (
                <p className="value-heading">
                  First Workout Trainer Rating
                  <span className="icon">
                    {rowData?.rating_id ? <CheckCircleIcon /> : <XCircleIcon />}
                  </span>
                </p>
              ) : null}
            </div>

            <div className="all-btns">
              {rowData?.handover_status === "pending" &&
              (isAdmin || isReceptionist || isFitnessManager) ? (
                <div className="lead-log-box">
                  <button
                    className="lead-log initiate-handover-btn"
                    onClick={(e) =>
                      onClickBtns(e, "initiate-handover", rowData)
                    }
                    style={{
                      background: "#066CE3",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M3.5 3H21.5V5H3.5V3ZM8.5 11V21H6.5V11H3.5L7.5 7L11.5 11H8.5ZM18.5 11V21H16.5V11H13.5L17.5 7L21.5 11H18.5Z"
                        fill="white"
                      />
                    </svg>
                  </button>

                  <span className="btn-label">Initiate handover</span>
                </div>
              ) : (isAdmin || isTrainer || isFitnessManager) &&
                rowData?.handover_status !== "pending" &&
                rowData?.trial_status === "pending" ? (
                <div
                  className="lead-log-box"
                  onClick={(e) => onClickBtns(e, "initate-pt-trial", rowData)}
                >
                  <button
                    className="lead-log start-pt-trial-btn"
                    style={{
                      background: "#066CE3",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M3.5 3H21.5V5H3.5V3ZM8.5 11V21H6.5V11H3.5L7.5 7L11.5 11H8.5ZM18.5 11V21H16.5V11H13.5L17.5 7L21.5 11H18.5Z"
                        fill="white"
                      />
                    </svg>
                  </button>

                  <span className="btn-label">Start PT Trial</span>
                </div>
              ) : null}

              <div className="lead-log-box">
                <button
                  className="lead-log edit-btn"
                  onClick={(e) =>
                    (rowData?.trial_status === "completed" ||
                      rowData?.trial_status === "converted" ||
                      rowData?.trial_status?.includes("cnvrtd")) &&
                    (isTrainer || isAdmin || isFitnessManager)
                      ? onClickBtns(e, "edit-pt-trial", rowData, "pt_trial")
                      : rowData?.handover_status === "completed" &&
                        (isReceptionist || isAdmin || isFitnessManager)
                      ? onClickBtns(e, "edit-handover", rowData, "handover")
                      : null
                  }
                  disabled={
                    (rowData?.trial_status !== "completed" ||
                      rowData?.trial_status !== "converted") &&
                    rowData?.handover_status !== "completed"
                  }
                  style={{
                    cursor:
                      rowData?.trial_status === "completed" ||
                      rowData?.trial_status === "converted" ||
                      rowData?.handover_status === "completed"
                        ? "pointer"
                        : "not-allowed",

                    boxShadow: !(
                      rowData?.trial_status === "completed" ||
                      rowData?.trial_status === "converted" ||
                      rowData?.handover_status === "completed"
                    )
                      ? "none"
                      : "",
                  }}
                >
                  <EditIcon1 />
                </button>

                <span className="btn-label">Edit</span>
              </div>

              {isAdmin ? (
                <div className="lead-log-box">
                  <button
                    className="lead-log delete-btn"
                    onClick={(e) =>
                      rowData?.trial_status !== "pending" &&
                      handleDelete(e, rowData?.uid)
                    }
                    disabled={rowData?.trial_status === "pending"}
                    style={{
                      cursor:
                        rowData?.trial_status === "pending"
                          ? "not-allowed"
                          : "pointer",
                      boxShadow:
                        rowData?.trial_status === "pending" ? "none" : "",
                    }}
                  >
                    <BinIcon1 />
                  </button>

                  <span className="btn-label">delete</span>
                </div>
              ) : null}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default CardAccordianInfo;
